// extracted by css-extract-rspack-plugin
export default {"conditions":"u8lb5y4YAMwYZKSg"};